var TscTextInputType = {
  text: 'text',
  // eslint-disable-next-line id-denylist, id-blacklist
  number: 'number',
  email: 'email',
  password: 'password',
  phone: 'tel',
  search: 'search',
  tel: 'tel',
  url: 'url'
};
export default TscTextInputType; // remove this after sufficient time and versions (JMD: 2022-04)

/**
 * @deprecated The use default TscTextInputType instead
 */

export { TscTextInputType as inputTypes };